<template>
  <b-tabs>
    <b-tab :title="$t('message.Общие')" active>
      <b-row>
        <b-col class="col-6">
          <b-form-group
            :label="$t('message.Пароль') + ':'"
            label-for="Password"
          >
            <b-form-input
              id="Password"
              type="text"
              v-model="model.password"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            :label="$t('message.Родительский_код') + ':'"
            label-for="ParentCode"
          >
            <b-form-input
              id="ParentCode"
              type="text"
              v-model="model.parent_code"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col6">
          <b-form-group
            :label="$t('message.Комментарий') + ':'"
            label-for="Сomment"
          >
            <b-form-input
              id="Comment"
              type="text"
              v-model="model.comment"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col class="col6">
          <b-form-group v-if="model.id"
            :label="$t('message.Токен') + ':'"
            label-for="ShortCode"
          >
            <b-form-input
              id="ShortCode"
              type="text"
              v-model="model.shortcode"
              readonly
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-6">
          <b-form-group :label="$t('message.Возраст') + ':'" label-for="Age">
            <b-form-input
              id="Age"
              type="number"
              v-model="model.age"
              value="0"
              min="0"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            :label="$t('message.Включен') + ':'"
            label-for="Enabled"
          >
            <b-form-checkbox
              v-model="model.enabled"
              id="Enabled"
              switch
            ></b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="col-6">
          <b-form-group
            :label="$t('message.Смещение_прямого_эфира') + ':'"
            label-for="TimeShift"
          >
            <b-form-input
              id="TimeShift"
              type="number"
              v-model="model.time_shift"
              value="0"
              min="0"
              max="12"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            :label="$t('message.Гео_контроль') + ':'"
            label-for="Geo_Enabled"
          >
            <b-form-checkbox
              v-model="model.geo_enabled"
              id="Geo_Enabled"
              switch
            ></b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col class="col-6"> </b-col>
      </b-row>
      <b-row>
        <b-col class="col-6">
          <b-form-group
            :label="$t('message.Колокейшн') + ':'"
            label-for="Colocation"
          >
            <v-select
              v-model="model.colocation"
              :options="this.colocations"
              label="name"
              required="required"
            ></v-select>
          </b-form-group>
        </b-col>
        <b-col class="col-6">
          <b-form-group :label="$t('message.Партнёр') + ':'" label-for="Member">
            <v-select
              v-model="model.member"
              :options="this.members"
              label="username"
              required="required"
              v-if="hasSetMemberPermission"
            ></v-select>
            <b-form-input
              id="member"
              type="text"
              :readonly="true"
              :value="getCurrentUser"
              v-if="!hasSetMemberPermission"
            >
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="col-6">
          <b-form-group
            :label="$t('message.Тип_аккаунта') + ':'"
            label-for="Type"
          >
            <v-select v-model="model.acc_type" :options="this.types" required>
            </v-select>
            <!-- label="name" -->
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            :label="$t('message.Тип_аккаунта_дата_обновления') + ':'"
            label-for="Updated"
          >
            <b-form-input
              id="acc_type_updated_at"
              type="text"
              v-model="model.acc_type_updated_at"
              :readonly="true"
              required
            >
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group :label="$t('message.Пакеты') + ':'" label-for="Packages">
        <v-select
          multiple
          v-model="model.packages"
          :options="this.packages"
          label="name"
        ></v-select>
      </b-form-group>
      <b-card title="VOD">
        <b-card-text>
          <b-row>
            <b-col class="col-6">
              <b-form-checkbox
                v-model="model.premier_enabled"
                id="PremierEnabled"
                switch
                >Premier</b-form-checkbox
              >
            </b-col>
            <b-col>
              <b-form-checkbox
                v-model="model.megogo_enabled"
                id="MegogoEnabled"
                switch
                >Megogo</b-form-checkbox
              >
            </b-col>
          </b-row>
        </b-card-text>
      </b-card>
    </b-tab>
    <b-tab title="Свойства" v-if="hasSetPropsPermission">
      <b-form-group
        :label="$t('message.Макс_потоков') + ':'"
        label-for="Max_streams"
      >
        <b-form-input
          id="Max_streams"
          type="number"
          v-model="model.max_streams"
          value="3"
          min="1"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        :label="$t('message.Макс_адресов') + ':'"
        label-for="Max_addresses"
      >
        <b-form-input
          id="Max_addresses"
          type="number"
          v-model="model.max_addresses"
          value="1"
          min="1"
        ></b-form-input>
      </b-form-group>
    </b-tab>

    <b-tab title="Vod Prime">
      <b-form-group :label="$t('message.Включен') + ':'" label-for="Enabled">
        <b-form-checkbox
          v-model="model.vod_enabled"
          id="Vod_Enabled"
          switch
        ></b-form-checkbox>
      </b-form-group>

      <b-form-group
        :label="$t('message.Видеотека_-_Пакеты') + ':'"
        label-for="Vod Packages"
      >
        <v-select
          multiple
          v-model="model.vod_packages"
          :options="this.vod_packages"
          label="name"
        ></v-select>
      </b-form-group>
    </b-tab>
  </b-tabs>
</template>
<script>
export default {
  name: "AccountForm",
  props: ["model"],
  data() {
    return {
      packages: [],
      vod_packages: [],
      colocations: [],
      members: [],
      types: []
    };
  },
  computed: {
    hasSetPropsPermission: function() {
      return !!this.$storage
        .get("current_user")
        .permissions.filter(value => value == "account:set_props").length;
    },
    hasSetMemberPermission: function() {
      return !!this.$storage
        .get("current_user")
        .permissions.filter(value => value == "account:set_member").length;
    },
    getCurrentUser: function() {
      return this.$storage.get("current_user").username;
    }
  },
  created: function() {
    let pro_packages = this.$noname.get("packages", {
      params: { perPage: 10000 }
    });
    let pro_vod_packages = this.$noname.get("vod_packages", {
      params: { perPage: 10000 }
    });
    let pro_colocations = this.$noname.get("colocations", {
      params: { perPage: 10000 }
    });
    let pro_members = this.$noname.get("users", {
      params: { perPage: 10000 }
    });
    let pro_types = this.$noname.get("acc_types_select", {
      params: { perPage: 10000 }
    });

    pro_packages
      .then(data => {
        this.packages = data.data.items;
      })
      .catch(this.$noname.HandleError);

    pro_vod_packages
      .then(data => {
        this.vod_packages = data.data.items;
      })
      .catch(this.$noname.HandleError);

    pro_colocations
      .then(data => {
        this.colocations = data.data.items;
      })
      .catch(this.$noname.HandleError);

    pro_members
      .then(data => {
        this.members = data.data.items;
      })
      .catch(this.$noname.HandleError);

    pro_types
      .then(data => {
        this.types = data.data.items;
      })
      .catch(this.$noname.HandleError);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/AccountForm.vue